import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SidebarWsBookmarked } from '../models';

@Injectable({providedIn: 'root'})
export class StaticbarService {

  constructor(private http: HttpClient) { }

  getFavouriteWorkspaces(): Promise<{ bookmarked: SidebarWsBookmarked[]; }>  {
    return this.http.get<{ bookmarked: SidebarWsBookmarked[]; }>(`${environment.apiUrl}/Homepage-GetFavouriteWorkspaces`).toPromise();
  }
}
